import React from "react";
import { createRoot } from "react-dom/client";
import StudentDocumentWorkspace from "./StudentDocumentWorkspace";

const ROOT_ID = "student-document-workspace-root";

const mount = () => {
  if (document.getElementById(ROOT_ID)) return;
  const container = document.createElement("div");
  container.id = ROOT_ID;
  document.body.appendChild(container);
  createRoot(container).render(<StudentDocumentWorkspace />);
};

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", mount, { once: true });
} else {
  mount();
}
